var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 19,
    viewBox: "0 0 27 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7653 3.73241C25.4709 2.62381 24.6034 1.75072 23.502 1.45442C21.5056 0.916016 13.5002 0.916016 13.5002 0.916016C13.5002 0.916016 5.4949 0.916016 3.49845 1.45442C2.39702 1.75077 1.52955 2.62381 1.23513 3.73241C0.700195 5.7418 0.700195 9.9342 0.700195 9.9342C0.700195 9.9342 0.700195 14.1266 1.23513 16.136C1.52955 17.2446 2.39702 18.0813 3.49845 18.3776C5.4949 18.916 13.5002 18.916 13.5002 18.916C13.5002 18.916 21.5055 18.916 23.502 18.3776C24.6034 18.0813 25.4709 17.2446 25.7653 16.136C26.3002 14.1266 26.3002 9.9342 26.3002 9.9342C26.3002 9.9342 26.3002 5.7418 25.7653 3.73241ZM10.882 13.7406V6.12781L17.5729 9.9343L10.882 13.7406Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.54f2f21de79a5a53c68cacaaf53b1318.svg";
export { ForwardRef as ReactComponent };